import api, { adminApiPrefix } from './Api';
import {
  Banner,
  bannerFromResponse,
  bannerToUpsertRequest,
} from '../interfaces/Banner/Banner';
import { BannerMediaOptions } from '../interfaces/Banner/BannerMediaOptions';
import { Pagination, paginationToParams } from '../interfaces/Pagination';
import { PaginatedResponse } from '../interfaces/PaginatedResponse';

const bannerAdminApiPrefix = `${adminApiPrefix}/banners`;

export const createBanner = async (banner: Banner): Promise<Banner> => {
  const response = await api.post(
    `${bannerAdminApiPrefix}/`,
    bannerToUpsertRequest(banner),
  );

  return bannerFromResponse(response.data?.data);
};

export const getBanners = async (
  pagination: Pagination,
): Promise<PaginatedResponse<Banner>> => {
  const response = await api.get(bannerAdminApiPrefix, {
    params: { ...paginationToParams(pagination), 'include-inactive': true },
  });

  return {
    data: (response.data?.data ?? []).map((banner: any) =>
      bannerFromResponse(banner),
    ),
    totalCount: response.data?.total_count ?? 0,
  };
};

export const getBanner = async (id: number): Promise<Banner> => {
  const response = await api.get(`${bannerAdminApiPrefix}/${id}`);

  return bannerFromResponse(response.data?.data);
};

export const updateBanner = async (banner: Banner): Promise<Banner> => {
  const response = await api.put(
    `${bannerAdminApiPrefix}/${banner.id}`,
    bannerToUpsertRequest(banner),
  );

  return bannerFromResponse(response.data?.data);
};

export const updateBannerMedia = async (
  id: number,
  options: BannerMediaOptions,
): Promise<Banner> => {
  const bodyFormData = new FormData();

  if (options.image) {
    bodyFormData.append('image', options.image);
  }

  if (options.eraseImage) {
    bodyFormData.append('erase-image', '1');
  }

  const response = await api.put(
    `${bannerAdminApiPrefix}/media/${id}`,
    bodyFormData,
  );

  return bannerFromResponse(response.data?.data);
};

export const deleteBanner = async (id: number): Promise<void> =>
  api.delete(`${bannerAdminApiPrefix}/${id}`);
